exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".used_style_09dd081{background-color:#52c41a}.default_style_bbff3a8,.used_style_09dd081{display:inline-block;width:5px;height:5px;border-radius:50%;vertical-align:middle;margin-right:5px}.default_style_bbff3a8{background-color:rgba(0,0,0,.25)}.repire_style_7137257{display:inline-block;width:5px;height:5px;background-color:#ff4d4f;border-radius:50%;vertical-align:middle;margin-right:5px}", ""]);

// exports
exports.locals = {
	"used_style": "used_style_09dd081",
	"default_style": "default_style_bbff3a8",
	"repire_style": "repire_style_7137257"
};